import angular from 'angular'

import { toString, isFunction } from 'lodash-es'

angular
  .module('ggs.frame')
  .directive('ggsFrame', FrameDirective)

function FrameDirective(Frame, applyAsync) {
  return {
    restrict: 'E',
    link($scope, $elm, $attr) {
      const src = toString($scope.$eval($attr.ggsFrameSrc))
      const events = $scope.$eval($attr.ggsFrameEvents)
      const attemptLimit = $scope.$eval($attr.ggsFrameAttemptLimit)
      const attemptDelay = $scope.$eval($attr.ggsFrameAttemptDelay)

      const frame = Frame(src, $elm, attemptLimit, attemptDelay)
      frame.load().then(onDone, onFail)
      $scope.$on('$destroy', onDestroy)

      function onDone(iframeElm) {
        if (isFunction(events.done)) {
          applyAsync($scope, events.done, iframeElm)
        }
      }

      function onFail(err) {
        if (isFunction(events.fail)) {
          applyAsync($scope, events.fail, err)
        }
      }

      function onDestroy() {
        frame.destroy()
      }
    }
  }
}
